import React, { Component } from "react";
import { auth } from "../firebase";
import axios from "axios";
import "./2/style.css";
import Logo from "./2/Controls/Logo";
import Input from "./2/Controls/Input";
import Button from "./2/Controls/Button";
import { isMobileApp } from "../actions/Util";
import { getUserIP } from "../services/api/CommonApi";
import { API_URL } from "../Constatnts";
import { resetTourForLogin } from "./CRM/crmTour";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginid: "",
      password: "",
    };
    this.onSignIn = this.onSignIn.bind(this);
  }

  componentDidMount() {
    document.title = this.props.config.WhiteLabel.Title;
    document.documentElement.style.setProperty(
      "--primary-clr",
      this.props.config.WhiteLabel.PrimaryColor
    );
    const favicon = document.getElementById("favicon");
    favicon.href = this.props.config.WhiteLabel.FavIcon;

    let loginid = window.localStorage.getItem("loginid");
    if (loginid) {
      this.setState({ loginid: loginid });
    }
  }

  onSignIn() {
    this.setState({ loading: true });
    let loginidError = "";
    let passwordError = "";
    if (this.state.loginid.trim() === "") {
      loginidError = "Please provide login id";
    }
    if (this.state.password.trim() === "") {
      passwordError = "Please provide password";
    }
    if (loginidError !== "" || passwordError !== "") {
      this.setState({
        loginidError: loginidError,
        passwordError: passwordError,
        loading: false,
      });
      return;
    }
    var storage = window.localStorage;
    storage.setItem("loginid", this.state.loginid);
    auth
      .signInWithEmailAndPassword(this.state.loginid, this.state.password)
      .then((result) => {
        const user = result.user;
        this.props.setAuthUser(user);
        this.props.getUserDetails(user.uid, true).then(async () => {
          if (this.props.user.user) {
            const userID = this.props.user.user.key
              ? this.props.user.user.key
              : "";
            const response = await axios.post(API_URL + "/user/adduser", {
              userId: userID,
              password: this.state.password,
            });
            if (response && response.data && response.data.token) {
              this.props.setUAT(response.data.token);
            }

            if (this.props.user.user.AccessibleToSpecificIP) {
              let ipResult = await getUserIP();
              if (ipResult.Success) {
                if (ipResult.Data.ip !== this.props.user.user.IPAddress) {
                  alert(
                    "User not allowed to access system from this IP Address"
                  );
                  this.setState({ loading: false });
                  return;
                }
              } else {
                alert("Unable to login. Please try again.");
                this.setState({ loading: false });
                return;
              }
            }
            this.props
              .getRegistration(this.props.user.user.RegistrationID)
              .then(() => {
                if (
                  this.props.registration &&
                  this.props.registration.registration.IsOldWebLoginDisabled
                ) {
                  alert(
                    "This account is not accessible on this website. Please use the new website to log in"
                  );
                  this.setState({ loading: false });
                  auth.signOut();
                  return;
                }
                resetTourForLogin();
                this.props.history.push("/home");
              });
          } else {
            this.props.history.push("/register");
          }
        });
      })
      .catch((error) => {
        alert(error);
        this.setState({ loading: false });
      });
  }

  render() {
    return (
      <div
        className={
          this.props.config.WhiteLabel.RegisterBackgroundCSS
            ? "login " + this.props.config.WhiteLabel.RegisterBackgroundCSS
            : "login"
        }
      >
        {isMobileApp() && <div className="header-new-background"></div>}
        <br />
        <br />
        <br />
        <div
          className={
            !isMobileApp() ? "login-container" : "login-container-mobile"
          }
        >
          <Logo
            {...this.props}
            logoOption={this.props.config.WhiteLabel.LoginLogoOption}
            height={
              this.props.config.WhiteLabel.LogoDefaultHeight
                ? this.props.config.WhiteLabel.LogoDefaultHeight
                : "122px"
            }
          />
          <div>
            <Input
              type="loginid"
              placeholder="Login id"
              onEnter={this.onSignIn}
              value={this.state.loginid}
              onChange={(value) =>
                this.setState({ loginid: value, loginidError: "" })
              }
              error={this.state.loginidError}
            />
            <br />
            <Input
              type="password"
              placeholder="Password"
              onEnter={this.onSignIn}
              value={this.state.password}
              onChange={(value) =>
                this.setState({ password: value, passwordError: "" })
              }
              error={this.state.passwordError}
            />
            <br />
            <Button
              type="primary"
              text="SIGN IN"
              onClick={this.onSignIn}
              processing={this.state.loading}
            />
            <br />
            <br />
            <center>
              <Button
                type="link"
                text="Forgot Password"
                onClick={() => {
                  this.props.history.push("/forgotpassword");
                }}
              />{" "}
            </center>
            <br />

            <br />
            <br />
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
